import React, { useEffect, useState } from "react";
import "./OurServices.css";
import {
  FaHome,
  FaBrain,
  FaHandsHelping,
  FaStethoscope,
  FaUserNurse,
  FaWalking,
  FaUsers,
  FaUtensils,
} from "react-icons/fa";

import { useTranslation } from "react-i18next";

const OurServices = () => {
  const { t } = useTranslation();

  const services = [
    { icon: <FaHome />, title: "assisted_living", desc: "assisted_living_desc" },
    { icon: <FaBrain />, title: "dementia_care", desc: "dementia_care_desc" },
    { icon: <FaHandsHelping />, title: "palliative_care", desc: "palliative_care_desc" },
    { icon: <FaStethoscope />, title: "medical_support", desc: "medical_support_desc" },
    { icon: <FaUserNurse />, title: "mental_health", desc: "mental_health_desc" },
    { icon: <FaWalking />, title: "recovery_rehab", desc: "recovery_rehab_desc" },
    { icon: <FaUsers />, title: "family_consults", desc: "family_consults_desc" },
    { icon: <FaUtensils />, title: "meals_nutrition", desc: "meals_nutrition_desc" },
  ];

  const groups = [services.slice(0, 4), services.slice(4, 8)];

  const [activeGroup, setActiveGroup] = useState(0);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveGroup((p) => (p === 0 ? 1 : 0));
      setActiveCard(null);
    }, 6000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="services-modern">
      <h2>{t("our_services_heading")}</h2>

      <div className="services-wrapper">
        {groups[activeGroup].map((item, i) => (
          <div
            key={i}
            className={`service-card ${activeCard === i ? "active" : ""}`}
            onMouseEnter={() => setActiveCard(i)}
            onClick={() => setActiveCard(i)}
          >
            <div className="service-icon">{item.icon}</div>
            <h4>{t(item.title)}</h4>
            <div className="service-underline" />
            <p>{t(item.desc)}</p>
          </div>
        ))}
      </div>

      <div className="services-dots">
        <span className={activeGroup === 0 ? "active" : ""} onClick={() => setActiveGroup(0)} />
        <span className={activeGroup === 1 ? "active" : ""} onClick={() => setActiveGroup(1)} />
      </div>
    </section>
  );
};

export default OurServices;